module.exports = __webpack_public_path__ + "static/media/ask-question.21530be5.png";